<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 md8 lg6>
          <SessionForm
            v-model="session"
            @submit="save"
            :backLink="session.url"
            title="Session bearbeiten"
            submitText="Aktualisieren"
            edit
          />
        </v-flex>
      </v-layout>
    </v-container>
  </BaseLayout>
</template>

<script>
import Business from '@/models/business';
import Session from '@/models/session';

export default {
  name: 'EditSession',
  requireSuperuser: true,
  async asyncData({ id }) {
    await Promise.all([
      Business.fetchAll(),
      Session.findOrFetch(id),
    ]);
  },
  data() {
    return {
      session: Session.query().with('businesses').find(this.$route.params.id),
    };
  },
  methods: {
    async save() {
      await this.session.update();
      this.$showSnackbar({ text: 'Erfolgreich gespeichert.', color: 'success' });
      this.$router.push(this.session.url);
    },
  },
};
</script>
